"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LAB_RESULT_IN_QUARANTINE () {
        return LAB_RESULT_IN_QUARANTINE;
    },
    get LAB_RESULT_IN_SIGNED_NOTE () {
        return LAB_RESULT_IN_SIGNED_NOTE;
    },
    get LAB_RESULT_MOVE_RETRY () {
        return LAB_RESULT_MOVE_RETRY;
    },
    get LAB_RESULT_MOVE_SAME_PATIENT () {
        return LAB_RESULT_MOVE_SAME_PATIENT;
    },
    get LabResultMoveReasonSchema () {
        return LabResultMoveReasonSchema;
    },
    get LabResultMoveRefActionSchema () {
        return LabResultMoveRefActionSchema;
    },
    get LabResultMoveRequestSchema () {
        return LabResultMoveRequestSchema;
    },
    get LabResultMoveResponseSchema () {
        return LabResultMoveResponseSchema;
    }
});
const _zod = require("zod");
const LabResultMoveReasonSchema = _zod.z.enum([
    // A linked OEM patient reference pointed at the wrong patient.
    'wrong_external_link',
    // Staff attached the result to the wrong patient from quarantine.
    'wrong_manual_attach',
    // The PhilHealth PIN on file matched the wrong patient.
    'wrong_philhealth_pin',
    'other'
]);
const LabResultMoveRefActionSchema = _zod.z.enum([
    'keep',
    'unlink',
    'relink'
]);
const LabResultMoveRequestSchema = _zod.z.object({
    toPatientId: _zod.z.string().uuid(),
    reason: LabResultMoveReasonSchema,
    refAction: LabResultMoveRefActionSchema,
    refId: _zod.z.string().uuid().optional()
}).strict().superRefine((body, ctx)=>{
    const needsRef = body.refAction !== 'keep';
    if (needsRef && body.refId === undefined) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'refId'
            ],
            message: 'refId is required for unlink and relink.'
        });
    }
    if (!needsRef && body.refId !== undefined) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'refId'
            ],
            message: 'refId is not allowed with keep.'
        });
    }
});
const LabResultMoveResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    fromPatientId: _zod.z.string().uuid(),
    toPatientId: _zod.z.string().uuid(),
    reason: LabResultMoveReasonSchema,
    refAction: LabResultMoveRefActionSchema,
    refId: _zod.z.string().uuid().nullable(),
    newRefId: _zod.z.string().uuid().nullable(),
    draftLinksRemoved: _zod.z.number().int().min(0),
    reviewCleared: _zod.z.boolean(),
    matchedByPin: _zod.z.boolean()
}).strict();
const LAB_RESULT_IN_SIGNED_NOTE = 'LAB_RESULT_IN_SIGNED_NOTE';
const LAB_RESULT_MOVE_SAME_PATIENT = 'LAB_RESULT_MOVE_SAME_PATIENT';
const LAB_RESULT_IN_QUARANTINE = 'LAB_RESULT_IN_QUARANTINE';
const LAB_RESULT_MOVE_RETRY = 'LAB_RESULT_MOVE_RETRY';
